var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDevicesCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#0033AD",
    fillOpacity: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 13.9989H29.9992V11.999H11.9998C10.8999 11.999 9.99992 12.899 9.99992 13.9989V24.9985H8V27.9984H21.9995V24.9985H11.9998V13.9989ZM30.9987 16.0004H24.9989C24.4489 16.0004 23.9989 16.4504 23.9989 17.0004V27C23.9989 27.55 24.4489 28 24.9989 28H30.9987C31.5486 28 31.9986 27.55 31.9986 27V17.0004C31.9986 16.4504 31.5486 16.0004 30.9987 16.0004ZM25.9999 24.9996H29.9997V17.9999H25.9999V24.9996Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDevicesCircle);
export default __webpack_public_path__ + "static/media/ic_devices_circle.8281f2858a91f75f8c74679a4c540a6d.svg";
export { ForwardRef as ReactComponent };